import { render, staticRenderFns } from "./DeLijn.vue?vue&type=template&id=1a0b1a4c&"
import script from "./DeLijn.vue?vue&type=script&lang=js&"
export * from "./DeLijn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports